/**
 * Parse error params GoTrue appends after a failed email-link verify.
 * They arrive on the hash (`#error=...`) or, less often, the query string.
 */
export interface AuthCallbackError {
  error: string;
  errorCode: string | null;
  errorDescription: string | null;
}

function paramsFrom(source: string, prefix: '?' | '#'): URLSearchParams {
  const trimmed = source.startsWith(prefix) ? source.slice(1) : source;
  return new URLSearchParams(trimmed);
}

export function parseAuthCallbackError(search: string, hash: string): AuthCallbackError | null {
  const fromQuery = paramsFrom(search, '?');
  const fromHash = paramsFrom(hash, '#');
  const error = fromHash.get('error') ?? fromQuery.get('error');
  if (!error) return null;

  const description = fromHash.get('error_description') ?? fromQuery.get('error_description');

  return {
    error,
    errorCode: fromHash.get('error_code') ?? fromQuery.get('error_code'),
    errorDescription: description ? description.replace(/\+/g, ' ') : null,
  };
}
